import { ReactNode } from 'react'

interface EmptyStateProps {
  icon?: ReactNode
  title: ReactNode
  text?: ReactNode
  /** A next step, such as a link or a button that creates the first item. */
  action?: ReactNode
  className?: string
}

/**
 * What a list or panel shows when it loaded fine and has nothing in it. Use
 * ErrorState when the load failed: "nothing here" and "couldn't load" must
 * never look the same.
 */
export function EmptyState({ icon, title, text, action, className = '' }: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center px-6 py-10 text-center ${className}`}>
      {icon ? (
        <div
          className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-surface-raised text-foreground-muted"
          aria-hidden="true"
        >
          {icon}
        </div>
      ) : null}
      <p className="font-display text-base font-semibold text-foreground">{title}</p>
      {text ? <div className="mt-1 max-w-md text-sm text-foreground-muted">{text}</div> : null}
      {action ? <div className="mt-4 flex flex-wrap items-center justify-center gap-2">{action}</div> : null}
    </div>
  )
}
